var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary mb-0"
        }, [_c('strong', [_vm._v("Multiple Maintenance Process")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.handleSubmit.apply(null, arguments);
            }
          }
        }, [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('div', {
          staticClass: "d-flex"
        }, [_c('b-form', {
          staticClass: "d-flex mb-3"
        }, [_c('b-form-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "id": "fleet_name",
            "type": "text",
            "placeholder": "Search fleet name..."
          },
          model: {
            value: _vm.jobList.params.search,
            callback: function callback($$v) {
              _vm.$set(_vm.jobList.params, "search", $$v);
            },
            expression: "jobList.params.search"
          }
        })], 1), _c('b-button', {
          staticClass: "d-flex align-items-center ml-2",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.modalFilter = true;
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders"
        }), _c('p', {
          staticClass: "text-truncate m-0"
        }, [_vm._v(" Filter Data")])])], 1), _c('div', [_c('b-button', {
          attrs: {
            "variant": "danger",
            "disabled": !_vm.hasCheckedItems
          },
          on: {
            "click": _vm.handleBulkDelete
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-alt mr-2"
        }), _vm._v("Bulk Delete ")])], 1)]), _c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table table-bordered table-hover"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', {
          staticClass: "sticky-col sticky-col-1"
        }, [_c('b-form-checkbox', {
          staticClass: "d-flex justify-content-center",
          attrs: {
            "checked": _vm.isCheckedAll
          },
          on: {
            "change": _vm.toggleSelectAll
          }
        })], 1), _c('th', {
          staticClass: "text-nowrap sticky-col sticky-col-2"
        }, [_vm._v("Fleet Name")]), _c('th', {
          staticClass: "text-nowrap sticky-col sticky-col-3",
          staticStyle: {
            "min-width": "240px"
          }
        }, [_vm._v(" Equipment Name ")]), _c('th', {
          staticClass: "text-nowrap",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_vm._v("Maintenance Date")]), _c('th', {
          staticClass: "text-nowrap",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_vm._v("Running Hours")]), _c('th', {
          staticClass: "text-nowrap",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_vm._v("Cost")]), _c('th', {
          staticClass: "text-nowrap",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_vm._v(" Maintenance File ")]), _c('th', {
          staticClass: "text-nowrap",
          staticStyle: {
            "min-width": "400px"
          }
        }, [_vm._v("Maintenance Note")])])]), _c('tbody', _vm._l(_vm.paginatedForms, function (job, index) {
          var _job$job_libraries;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "sticky-col sticky-col-1"
          }, [_c('b-form-checkbox', {
            staticClass: "d-flex justify-content-center",
            attrs: {
              "type": "checkbox",
              "value": job.unique_id
            },
            model: {
              value: _vm.checkedJobs,
              callback: function callback($$v) {
                _vm.checkedJobs = $$v;
              },
              expression: "checkedJobs"
            }
          })], 1), _c('td', {
            staticClass: "sticky-col sticky-col-2"
          }, [_c('b-badge', {
            attrs: {
              "variant": "success"
            }
          }, [_vm._v(_vm._s(job.vehicle_name))])], 1), _c('td', {
            staticClass: "sticky-col sticky-col-3"
          }, [_vm._v(" " + _vm._s((_job$job_libraries = job.job_libraries) === null || _job$job_libraries === void 0 ? void 0 : _job$job_libraries.maintenance_master.equipment_name) + " ")]), _c('td', {
            staticStyle: {
              "min-width": "180px"
            }
          }, [_c('date-picker', {
            attrs: {
              "value-type": "YYYY-MM-DD"
            },
            model: {
              value: job.job_libraries.maintenance_date,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "maintenance_date", $$v);
              },
              expression: "job.job_libraries.maintenance_date"
            }
          })], 1), _c('td', {
            staticStyle: {
              "min-width": "180px"
            }
          }, [_vm.method == 'COUNTER' ? _c('b-input-group', {
            attrs: {
              "append": "Hours"
            }
          }, [_c('b-form-input', {
            attrs: {
              "type": "number",
              "min": "0",
              "placeholder": "Enter hours"
            },
            model: {
              value: job.job_libraries.last_maintenance_interval_hour,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "last_maintenance_interval_hour", $$v);
              },
              expression: "\n                        job.job_libraries.last_maintenance_interval_hour\n                      "
            }
          })], 1) : _vm._e()], 1), _c('td', {
            staticStyle: {
              "min-width": "180px"
            }
          }, [_c('InputCurrency', {
            attrs: {
              "type": "number",
              "min": "0",
              "placeholder": "Enter hours"
            },
            model: {
              value: job.job_libraries.cost,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "cost", $$v);
              },
              expression: "job.job_libraries.cost"
            }
          })], 1), _c('td', {
            staticStyle: {
              "min-width": "400px"
            }
          }, [_c('b-form-file', {
            attrs: {
              "placeholder": "Choose file...",
              "browse-text": "Browse",
              "multiple": ""
            },
            on: {
              "input": function input(files) {
                return _vm.onFilesSelected(job, files);
              }
            },
            model: {
              value: job.job_libraries.attachments,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "attachments", $$v);
              },
              expression: "job.job_libraries.attachments"
            }
          }), _vm.normalizeFiles(job.job_libraries.attachments).length ? _c('div', {
            staticClass: "mt-2"
          }, _vm._l(_vm.normalizeFiles(job.job_libraries.attachments), function (f, fi) {
            return _c('b-badge', {
              key: "att-".concat(index, "-").concat(fi),
              staticClass: "mr-2",
              attrs: {
                "variant": "info"
              }
            }, [_vm._v(" " + _vm._s(f.name || 'attachment') + " "), _c('i', {
              staticClass: "fa fa-times ml-1 cursor-pointer",
              attrs: {
                "title": "Remove"
              },
              on: {
                "click": function click($event) {
                  $event.stopPropagation();
                  return _vm.removeAttachment(job, fi);
                }
              }
            })]);
          }), 1) : _vm._e()], 1), _c('td', {
            staticStyle: {
              "min-width": "400px"
            }
          }, [_c('b-form-input', {
            attrs: {
              "placeholder": "Enter note"
            },
            model: {
              value: job.job_libraries.maintenance_note,
              callback: function callback($$v) {
                _vm.$set(job.job_libraries, "maintenance_note", $$v);
              },
              expression: "job.job_libraries.maintenance_note"
            }
          })], 1)]);
        }), 0)])]), _c('div', {
          staticClass: "my-4 d-flex align-items-center w-100 justify-content-between"
        }, [_c('p', [_vm._v(" Total Rows: "), _c('strong', {
          staticClass: "text-black fw-bold"
        }, [_vm._v(_vm._s(_vm.totalRows))])]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.totalRows,
            "per-page": _vm.jobList.params.limit,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.onPageChange
          },
          model: {
            value: _vm.jobList.params.page,
            callback: function callback($$v) {
              _vm.$set(_vm.jobList.params, "page", $$v);
            },
            expression: "jobList.params.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "change": _vm.onLimitChange
          },
          model: {
            value: _vm.jobList.params.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.jobList.params, "limit", $$v);
            },
            expression: "jobList.params.limit"
          }
        })], 1)]), _c('div', {
          staticClass: "d-flex"
        }, [_c('b-button', {
          staticClass: "w-50 mr-2",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              return _vm.$emit('close');
            }
          }
        }, [_vm._v(" Cancel ")]), _c('b-button', {
          staticClass: "w-50",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.handleSubmit
          }
        }, [_vm._v(" Save ")])], 1)])];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }